import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { resetPasswordOTP } from "../api/authApi";

const ResetPassword = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const phone = localStorage.getItem("resetPhone");
  const otp = localStorage.getItem("resetOTP");
  
console.log("Phone from localStorage:", phone);
console.log("OTP from localStorage:", otp);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

 console.log("Form Submitted!", { phone, otp, password });

    if (!password) {
      setError("Password is required");
      return;
    }

    if (password.length < 6) {
      setError("Password must be at least 6 characters");
      return;
    }
   console.log("Reset Payload:", { phone, otp, newPassword: password });
    try {
    const data=  await resetPasswordOTP(phone, otp, password);
    console.log("Reset Response:", data); 
      // clear stored values
      localStorage.removeItem("resetPhone");
      localStorage.removeItem("resetOTP");

      alert("Password reset successful!");
      navigate("/login");
    } catch (err) {
      setError(err.response?.data?.message || "Reset failed");
    }
  };

  return (
    <div className="flex justify-center items-center h-screen bg-[#f4ede4]">
      <div className="w-full max-w-md bg-white p-8 rounded-xl shadow">
        <h2 className="text-3xl font-semibold mb-6">Reset Password</h2>

        {error && <p className="text-red-500 mb-4">{error}</p>}

        <form onSubmit={handleSubmit} className="space-y-6">
          <input
            type="password"
            placeholder="Enter new password"
            className="w-full border-b py-3 focus:outline-none"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <button className="w-full bg-black text-white py-3 rounded-full">
            Reset Password
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
